import { configureStore } from '@reduxjs/toolkit';
import authReducer from './slices/authSlice';
import { aroApiSlice } from './slices/apiSlice/apiSlice';
import mapReducer from './slices/mapSlice';
import datagridReducer from './slices/datagridSlice';
import { initPropertySyncListener } from '../services/listeners';

export const store = configureStore({
    reducer: {
        auth: authReducer,
        map: mapReducer,
        datagrid: datagridReducer,
        [aroApiSlice.reducerPath]: aroApiSlice.reducer,
    },
    middleware: (getDefaultMiddleware) => {
        return getDefaultMiddleware({ serializableCheck: false }).concat(
            aroApiSlice.middleware
        );
    },
});

initPropertySyncListener(store);
